import { render } from "./IdCalendar.vue?vue&type=template&id=36162331&scoped=true"
import script from "./IdCalendar.vue?vue&type=script&lang=js"
export * from "./IdCalendar.vue?vue&type=script&lang=js"

import "./IdCalendar.vue?vue&type=style&index=0&id=36162331&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36162331"]])

export default __exports__